import React from 'react'

const SectionAbout = () => {
    return (
      <div>    
        <h1>ABOUT</h1>
      </div>
    )
}

export default SectionAbout



// WEBPACK FOOTER //
// ./src/pages/About/SectionAbout.js